import { motion } from "framer-motion";
import "./mpc.scss";

function Mpc({ content }) {
  return (
    <motion.div
      className="mpc"
      initial={{ y: 200 }}
      whileInView={{ y: 0 }}
      transition={{
        type: "spring",
        bounce: 0.2,
        duration: 1,
      }}
      viewport={{ once: true }}
    >
      <div className="mpc__container">
        <div className="member__image">
          <img src={content?.imageMember} alt="" />
        </div>
        <div className="member__content">
          <div className="member__content__title">
            <span>{content?.titleMember}</span>
          </div>
          <div className="member__content__desc">
            {/* <p>{content?.descMember}</p> */}
            <p>{content?.descBanner}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Mpc;
